import React, { useState } from 'react'
import CompanyInfo from './ProCompanyInfo'
import { ProHeader, ProInfoSidebar, ProSVGIcons } from '.'
import diversity from '../../img/about/diversity.png'
import skill from '../../img/about/skill.png'
import flexibility from '../../img/about/flexibility.png'
import TranslateText from '../TranslateText'
import { useLanguage } from '../../hooks/useLanguage'
import backgroundImageUrl from '../../img/work-bg.svg'

export const ServiceItem = ({ icon, title, subTitle, delay, content }) => (
  <a className='h-full hover:bg-gray-100 h-80 bg-white' style={{ animationDelay: delay }}>
    <div className='flex flex-col items-center p-4 border border-gray-200 rounded shadow h-96 lg:h-[450px] lg:p-10 xl:px-12'>
      <ProSVGIcons icon={icon} />
      <h3 className='text-2xl pt-3 font-semibold mt-2 text-center font-serif'>
        {title}
      </h3>
      <h4 className='text-customYellow text-lg font-jp'>
        {subTitle}
      </h4>
      <p className='text-gray-600 font-jp text-sm pt-8 pb-4'>
        {content}
      </p>
    </div>
  </a>
)

export default function ProServices() {
  // const { lang } = useLanguage()

  return (
    <section id='services' className='case-study-three case-study bg-white' style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
      <div className='container mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-8'>
        <div className='w-full'>
          {/* <div className="case-study-three__top-wrap sec-title__top-wrap">
          <p className="text-customYellow font-jp text-lg">{LocalMessage.portfolio[lang]}</p>
        </div> */}
          <p className='text-customGreen font-jp font-semibold text-center'>サービス内容</p>
          <h1 className='text-center lg:text-5xl font-serif'>Services</h1>
        </div>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 py-6 lg:py-10 px-3 lg:px-10 xl:px-28 xl:gap-10'>
        <ServiceItem icon='webDesign' title='Web Design' subTitle='webデザイン' delay='0.1s' content='Webデザインとはただ見た目がおしゃれなデザインを作ることでなく、実際にサイトを訪れるお客様を問い合わせや、購入等のゴールに導くためにデザインすることが大切です。
お客様が納得のいくサイトができるよう
コミュニケーションをとりながら
デザイン作成をします。' />
        <ServiceItem icon='webDev' title='Web Development' subTitle='web開発' delay='0.3s' content='ウェブサイトの開発はもちろん
弊社ではシステムやアプリケーション等の開発もしております。' />
        <ServiceItem icon='marketing' title='Long Term Online Marketing' subTitle='SEO対策' delay='0.3s' content='検索した時にお客様のビジネスがウェブ上に表示するようにするにはしっかりと対策をしっかりとする必要があります。
弊社ではサイト作成後のSEOの対策も
しております。' />
        <ServiceItem icon='frame' title='Ecommerce Development' subTitle='ECサイト構築' delay='0.5s' content='私たちは、革新的なガジェットのギアを特徴とし、カスタマイズされたShopifyアプリ開発、強力なE-コマースウェブサイトの設計および開発、E-コマースソリューションの提供、E-コマースの国際化サービス、および洞察に富んだE-コマース分析を提供します。' />
        <ServiceItem icon='customisation' title='Customisation' subTitle='カスタム機能の追加' delay='0.3s' content='NEWS フィード、Blog創設、チャット機能
イベントのためのランディングページの
作成等弊社ではお客様のニーズに合わせて
パッケージプランには入っていない
カスタム機能の追加等もおこなっております。' />
        <ServiceItem icon='connect' title='Connect' subTitle='接続・同期' delay='0.5s' content='Webサイトの分析に欠かせない
Google Analyticsとの接続や
SNSサイトとの接続等も承ります。' />
      </div>

    </section>
  )
}
